<template>
  <transition name="slide-fade">
    <v-btn small :icon="$breakpoint.smAndDown" @click.stop.prevent="goTo(href)" :href="href" outlined :title="title" color="green darken-2" :disabled="disabled">
      <slot name="icon">
        <v-icon :left="!$breakpoint.smAndDown">mdi-cash</v-icon>
      </slot>
      <span v-if="!$breakpoint.smAndDown">
        <slot name="text">Invoices</slot>
      </span>
    </v-btn>
  </transition>
</template>

<script>
  export default {
    name: 'InvoiceButton',
    props: {
      href: {
        type: String,
        default: '#'
      },
      title: {
        type: String,
        default: 'Invoices'
      },
      disabled: Boolean
    }
  }
</script>

<style>

</style>
